export default __webpack_public_path__ + "static/russland-analysen-d09e0f09721f189a4c516b653bb42e9c.png";